import { styled } from '../../Styles/stitches.config'

export const StyledStepper = styled('div', {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
})

export const CurrentStepLine = styled('div', {
    position: 'absolute',
    bgc: '$primary600',
    h: '1px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: '1',
    transition: 'all .8s ease-in-out',
})

export const DefaultLine = styled('div', {
    position: 'absolute',
    bgc: '$neutral300',
    h: '1px',
    w: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
})

export const StyledCircle = styled(StyledStepper, {
    flexDirection: 'column',
    bgc: '$neutral300',
    size: 14,
    br: '50%',

    transition: 'all .4s ease-in-out',
    zIndex: '2',

    variants: {
        colored: {
            true: {
                bgc: '$primary600',
                transition: 'all 1.8s ease-in-out',
            },
        },
    },
})
